import React from 'react'

export default function Button({ style, btnIcon, btnName, clicked, disable=false,padding=false , handleKeypress }) {
    const cssClasses = {
        button: {
            padding: padding ? padding : '1rem 1.6rem',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          "& :hover" :{
            cursor:"pointer",
          },
        
        },
        buttonWrapper: {
            boxSizing: 'border-box',
            boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
            borderRadius: '0.8rem',
            width:"100%",
            cursor:"pointer"
        },
        image: {
            display: 'inline-block',
            verticalAlign: 'middle',
            width: '1.4rem',
            height: '1.4rem',
            marginRight: '1rem'
        },
        btnText: {
            fontWeight: '500',
            fontSize: '1.4rem',
            lineHeight: '2rem',
            verticalAlign: 'middle',
            display: 'inline-block',
            margin: '0',
        }
    }

    return (
        <div  
        tabIndex="0" 
        onKeyPress={handleKeypress}
        style={{ ...cssClasses.buttonWrapper,
             color: style.color,
             backgroundColor: style.backgroundColor, 
            opacity: disable ? "0.7" : "1", 
            pointerEvents : disable ? "none" : "auto",
          border: style.backgroundColor.toLowerCase().includes("fff") ? "1px solid #D0D5DD" : ""  }} onClick={clicked}>
        {btnIcon ? 
            <div style={cssClasses.button}>
            <img style={{ ...cssClasses.image, color: style.color }} src={btnIcon} alt="Icon" />
                <p style={cssClasses.btnText}>{btnName}</p>
            </div>
            :
            <div style={cssClasses.button}>
                <p style={cssClasses.btnText}>{btnName}</p>
            </div>
        }
        </div>
    )
}